import Ext from "Ext"
import $ from "jquery"
import View from "../../View"
import GroupType from "../../enums/GroupType"
import {NodeRenderer as NodeRenderP, SelectorPanel as SelectorPanelP} from "../../panels/usersAssignedToHierarchy/UsersSelector"
import TwoLevelSelection from "../../controls/selectorControls/two_level_selection"
import SharedUserButtonMenu from "../../controls/selectorControls/at_shared_user_button_menu"
import {getTitleOfGenerateMoneyReportsRight, getTitleOfModifyTimeTrackRight} from '../../panels/usersAssignedToHierarchy/utils'
import {isEsc, onKeyDown} from '../../keyHandlers'

export default class CopyUserSelector extends View {
    constructor({
        selectionCallback = (selectedUser) => {},
        onHideCb = () => {},
        title = '',
        showPermissionIcons = false,
        renderTo = null,
    }) {
        super()

        this.selectionCallback = selectionCallback
        this.onHideCb = onHideCb
        this.showPermissionIcons = showPermissionIcons
        this.title = title
        this.renderTo = renderTo

        this._restoreOldKeydownHandler = null

        this.state = {
            users: [],
            ugrEnabled: false,
            userGroups: [],
            groupBy: GroupType.USER_GROUP,
            tzgEnabled: false,
            timeZoneGroups: [],
            isURAEnabled: false,
            isBTYEnabled: false,
            isTTAEnabled: false,
        }

        this.onStateDeeplyChanged(() => this._initPanel())
    }

    showAt($el, position) {
        this.menu.show($el[0], position)
        this._subscribeEscapeEventListener()
    }

    hide() {
        this.menu.hide()
        this._unsubscribeEscapeEventListener()
    }

    _initPanel() {
        this.panel = new SelectorPanel({
            showPermissionIcons: this.showPermissionIcons,
            selectionCallback: this.selectionCallback,
            title: this.title,
            showGenerateMoneyReportsIcon: this.state.isURAEnabled || this.state.isBTYEnabled,
            generateMoneyReportsIconTooltip: getTitleOfGenerateMoneyReportsRight(this.state.isBTYEnabled, this.state.isURAEnabled),
            modifyTimeTrackTooltipText: getTitleOfModifyTimeTrackRight(this.state.isTTAEnabled),
        })

        this.panel.initialize(
            this.state.ugrEnabled,
            this.state.tzgEnabled,
            this.state.users,
            this.state.userGroups,
            this.state.timeZoneGroups
        )
        this.panel.loadState({
            selection: new TwoLevelSelection([], []),
            groupType: this.state.groupBy,
            additionalCheckBoxValue: false,
            optionValue: false,
            showInactive: false
        })

        this.menu = new SharedUserButtonMenu({
            panel: this.panel,
            parentEl: this.renderTo[0],
        })

        this.menu.on('hide', () => {
            this.onHideCb()
            this._unsubscribeEscapeEventListener()
        })
    }

    onUserDeleted(deletedUserId) {
        this.setState({
            users: this.state.users.filter((u) => u.id !== deletedUserId)
        })
    }

    _subscribeEscapeEventListener() {
        this._restoreOldKeydownHandler = onKeyDown((keycode, e) => {
            if (isEsc(keycode)) {
                this.hide()
                return true
            }
        })
    }

    _unsubscribeEscapeEventListener() {
        if (this._restoreOldKeydownHandler)
            this._restoreOldKeydownHandler();
    }
}


class NodeRenderer extends NodeRenderP {
    constructor({
        selectorTree,
        selectorFilter,
        selectionHelper,
        showPermissionIcons,
        showGenerateMoneyReportsIcon = false,
        generateMoneyReportsIconTooltip = "",
        modifyTimeTrackTooltipText = "",
        onSelectCallback = () => {}
    }) {
        super({
            selectorTree,
            selectorFilter,
            selectionHelper,
            showPermissionIcons,
            showGenerateMoneyReportsIcon,
            generateMoneyReportsIconTooltip,
            modifyTimeTrackTooltipText,
        })
        this.params = {
            onSelectCallback
        }
    }

    generateContent(treeNode, targetEl) {
        super.generateContent(treeNode, targetEl)

        $(targetEl).click(() => this.params.onSelectCallback(treeNode.getValue()))
    }
}

const SelectorPanel = Ext.extend(SelectorPanelP, {

    constructor(config) {
        SelectorPanel.superclass.constructor.call(this, config)
        this.selectionCallback = config.selectionCallback
        this.title = config.title
        this.hideSelect = true
        this.showGenerateMoneyReportsIcon = config.showGenerateMoneyReportsIcon
        this.generateMoneyReportsIconTooltip = config.generateMoneyReportsIconTooltip
        this.modifyTimeTrackTooltipText = config.modifyTimeTrackTooltipText
    },

    createComponents() {
        SelectorPanelP.superclass.createComponents.call(this)
        this.addClass("copySettingsUserSelector")
        if (this.showPermissionIcons) {
            this.addClass("withPermissionIcons")
        }
    },

    getUserNodeRenderer() {
        return new NodeRenderer({
            selectorTree: this.selectorTree,
            selectorFilter: this.selectorFilter,
            selectionHelper: this.getSelectionHelper(),
            showPermissionIcons: this.showPermissionIcons,
            showGenerateMoneyReportsIcon: this.showGenerateMoneyReportsIcon,
            generateMoneyReportsIconTooltip: this.generateMoneyReportsIconTooltip,
            modifyTimeTrackTooltipText: this.modifyTimeTrackTooltipText,
            onSelectCallback: this.selectionCallback,
        })
    },

    getCustomOptionSection() {
        return [
            new Ext.Container({
                cls: "copyUserSelectorLabelWrapper",
                autoEl: "div",
                items: new Ext.form.Label({
                    cls: "copyUserSelectorLabel",
                    text: this.title,
                })
            }),
            new Ext.Container({
                cls: "userSelectorCustomControlsContainer",
                autoEl: "div",
                items: [this.viewByPanel, this.getCustomOptionButtonsSection()]
            })
        ]
    },

    getCustomOptionButtons: function() {
        const buttons = []
        buttons.push(this.filterButton, this.makeVerticalSeparator())
        if (this.canExpandCollapseNodes()) {
            buttons.push(this.collapseAllButton, this.expandAllButton)
        }

        return buttons
    },

    getFooterSection() {
        return []
    },

    getFilterWordsPopupCoordinates() {
        return this.userGroupsEnabled || this.timeZoneGroupsEnabled ? {x: -92, y: -3} : {x: 2, y: -3}
    }
})


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/CopyUserSelector.js